export default {"src":"/_next/static/media/TROW.8fea824d.svg","height":18,"width":18};